import { useState, useRef, useEffect } from 'react'

export default function WhyChooseUs() {
  const tabs = [
    { 
      id: 'confianza', 
      label: 'Confianza y Seguridad', 
      content: 'Con más de 20 años de experiencia en el mercado cambiario, Del Sol es sinónimo de confianza. Operamos con total transparencia y cumplimos con todas las regulaciones financieras para garantizar transacciones 100% seguras.'
    },
    { 
      id: 'tasas', 
      label: 'Mejores Tasas', 
      content: 'Ofrecemos las tasas de cambio más competitivas del mercado. Actualizamos nuestros tipos de cambio diariamente para que siempre obtengas el mejor valor por tu dinero, sin comisiones ocultas.'
    },
    { 
      id: 'rapidez', 
      label: 'Servicio Rápido', 
      content: 'Entendemos que tu tiempo es valioso. Nuestro proceso es ágil y eficiente: en minutos puedes realizar tus cambios de divisas o transferencias internacionales con la atención personalizada que mereces.'
    }
  ]

  const [active, setActive] = useState('tasas')
  const tabRefs = useRef([])
  const [indicator, setIndicator] = useState({ left: 0, width: 0 })

  useEffect(() => {
    function update() {
      const index = tabs.findIndex(t => t.id === active)
      const el = tabRefs.current[index]
      if (el) {
        const rect = el.getBoundingClientRect()
        const parentRect = el.parentElement.getBoundingClientRect()
        setIndicator({ left: rect.left - parentRect.left + 'px', width: rect.width + 'px' })
      }
    }
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [active])

  const activeTab = tabs.find(t => t.id === active)

  return (
    <section className="py-16 bg-brand-white" id="por-que-elegirnos">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-12 text-center" style={{ color: 'var(--brand-accent)' }}>
          ¿Por Qué Elegirnos?
        </h2>

        {/* Tabs navigation */}
        <div className="flex justify-center mb-8">
          <div className="tab-list" style={{ position: 'relative', display: 'inline-flex' }}>
            <div className="flex gap-8">
              {tabs.map((tab, i) => (
                <div 
                  key={tab.id} 
                  className="tab-item" 
                  ref={el => tabRefs.current[i] = el}
                >
                  <button
                    role="tab"
                    aria-selected={active === tab.id}
                    onClick={() => setActive(tab.id)}
                    className={`focus:outline-none px-4 py-2 ${active === tab.id ? 'font-bold' : 'font-semibold'}`}
                    style={{ 
                      color: active === tab.id ? 'var(--brand-accent)' : 'var(--muted-3)',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    {tab.label}
                  </button>
                </div>
              ))}
            </div>
            <div 
              className="tab-indicator" 
              style={{ 
                left: indicator.left, 
                width: indicator.width 
              }} 
            />
          </div>
        </div>

        {/* Tab content */}
        <div className="flex justify-center">
          <div className="tab-content active" style={{ maxWidth: '700px', width: '100%' }}>
            <p className="text-center leading-relaxed" style={{ color: 'var(--text)' }}>
              {activeTab?.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}